// src/LexUniverse/FullscreenSketchfab.jsx
import React from 'react';

export default function FullscreenSketchfab() {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: 0,
      paddingBottom: '56.25%',  // 9/16 * 100%
      margin: 0,
    }}>
      <iframe
        title="Future City 6001"
        src="https://sketchfab.com/models/cc60ba5dbd014d63839935c0e89eae53/embed?autostart=1&annotations_visible=1&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0"
        style={{
          position: 'absolute',
          top: 0, left: 0,
          width: '120%',
          height: '120%',
          border: 0,
        }}
        allow="autoplay; fullscreen; xr-spatial-tracking"
        mozAllowFullScreen
        webkitAllowFullScreen
        allowFullScreen
      />
    </div>
  );
}
